<template>
  <b-card
  body-class='p-0'
  >
    <div class="empty-page">
      <i :class="icon" class="empty-page-icon mb-3"></i>
      <h5 class="mb-2">{{ title }}</h5>
      <p class="text-muted mb-0">{{ description }}</p>
      <b-button
        v-if="buttonLabel"
        variant="pgiBtn"
        class="mt-3 mb-1"
        @click="onButtonClick"
      >
        {{ buttonLabel }}
      </b-button>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "EmptyPage",
  props: {
    title: {
      type: String,
      default: "Data tidak tersedia",
    },
    description: {
      type: String,
      default: "Tidak ada data yang dapat ditampilkan.",
    },
    icon: {
      type: String,
      default: "fa fa-calendar-check-o",
    },
    buttonLabel: {
      type: String,
      default: "",
    },
    buttonTo: {
      type: String,
      default: "",
    },
  },
  methods: {
    onButtonClick() {
      if (this.buttonTo) {
        this.$router.push({ path: this.buttonTo });
        return;
      }

      this.$emit("button-click");
    },
  },
};
</script>

<style scoped>
.empty-page {
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 28px 16px 24px;
}

.empty-page-icon {
  color: #b9c1ca;
  font-size: 54px;
  line-height: 1;
}
</style>
